import { Button, Select, Table, Text } from '@pentabd/ui';

import { useCenterWiseResults } from '@hooks/useCenterWiseResults';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import {
  Controller,
  FormProvider,
  SubmitHandler,
  useForm,
} from 'react-hook-form';
import { allTimeSlots, autoSlotSelector } from '@utils/utils';
import {
  HeaderExtensionCenterWiseTable,
  centerWiseResultsColumn,
} from '../constants';

export const resultsSearchValidation = yup.object().shape({
  timeSlot: yup.string(),
});

export type ResultsSearchFormDataType = yup.InferType<
  typeof resultsSearchValidation
>;

export function CenterWiseResultsTable() {
  const { centerWisResults, isLoading, handleQuery, query } =
    useCenterWiseResults();

  const { t } = useTranslation();

  const methods = useForm({
    defaultValues: {
      timeSlot: autoSlotSelector().showSlotRange,
    },
  });

  const { handleSubmit, register, control, setValue } = methods;

  const onSubmit: SubmitHandler<ResultsSearchFormDataType> = (data: any) => {
    handleQuery('timeSlot', data?.timeSlot || '');
  };

  return (
    <div className="py-10">
      <div className="bg-light p-10 mb-10 rounded">
        <FormProvider {...methods}>
          <form className="container" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-3">
                <Text
                  weight="semibold"
                  size="md"
                  color="title"
                  component="p"
                  className="mb-5"
                >
                  {t('CENTER_WISE_RESULTS.BODY.SEARCH_FORM.TIME_SLOT.LABEL')}
                </Text>

                <Controller
                  control={control}
                  name={'timeSlot'}
                  render={({ field }) => {
                    return (
                      <Select
                        {...register(`timeSlot`)}
                        options={allTimeSlots}
                        defaultValue={field.value as string}
                        placeholder={t(
                          'CENTER_WISE_RESULTS.BODY.SEARCH_FORM.TIME_SLOT.PLACEHOLDER',
                        )}
                        onSelectItem={(e) => {
                          setValue('timeSlot', e as string);
                        }}
                        disabled={isLoading}
                        portal={true}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-sm-12 col-md-6 col-lg-3 align-self-end">
                <Button
                  fill="fill"
                  size="md"
                  type="info"
                  htmlType="submit"
                  isPadding={false}
                  className="px-20 py-5"
                  disabled={isLoading}
                >
                  {t(
                    'CENTER_WISE_RESULTS.BODY.SEARCH_FORM.SEARCH_BUTTON.LABEL',
                  )}
                </Button>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>

      <Table
        headerExtension={HeaderExtensionCenterWiseTable({
          isLoading,
          centerWisResults,
          handleQuery,
          query,
        })}
        loading={isLoading}
        loadingItemCount={10}
        columns={centerWiseResultsColumn({ t })}
        rows={centerWisResults?.getData}
        pagination={{
          totalPage: Math.ceil(centerWisResults?.total / query?.size),
          onClick: (currentPage) => {
            handleQuery('page', currentPage);
          },
          activePage: query?.page,
        }}
      />
    </div>
  );
}
